export class SolicitudEditRegistroModel {

  CodigoRadicado?: number;
  CodigoRNT?: number;
  Categoria_Id?:number;
  sub_categoria_id?:number;
  solicitud_id?:number;
  detalle_solicitud_id?:number;

  establecimiento_Id?:number;
  codigo_camara?:number;
  tipo_rnt_id?:number;
  rnt_id?:number;
  tipo_solicitud_id?:number;
}
